// @flow

import { Form, Select } from 'antd';
import React, {useEffect} from 'react';
import {areCountriesLoading, canAutoFetchCountries, getUICountries} from '../redux/selectors/countriesSelectors';
import {useDispatch, useSelector} from 'react-redux';

import {fetchCountries} from '../redux/actions/entitiesActions';

const { Option } = Select;

type Props = {
  +form: Object,
  +initVal?: ?string,
  +label?: ?string,
  +fieldName: string
}

const CountriesSelectItem = (props: Props) => {
  const dispatch = useDispatch();
  const countries = useSelector(getUICountries);
  const canFetchCountries = useSelector(canAutoFetchCountries);
  const isLoading = useSelector(areCountriesLoading);

  useEffect(() => {
    if (canFetchCountries) {
      dispatch(fetchCountries());
    }
  }, [canFetchCountries, dispatch]);

  return (
    <Form.Item name={props.name} label={props.label || "Country"} hasFeedback initialValue={props.initVal} dependencies={props.dependencies}
      rules={[{ required: true, message: 'Please select a country' }]}>
        <Select loading={isLoading} showSearch filterOption={(val, option) =>
            option.children && val &&  option.children.toLowerCase().indexOf(val.toLowerCase()) >= 0}>
          {
            countries.map(c => <Option key={c.value} value={c.value}>{c.label}</Option>)
          }
        </Select>
    </Form.Item>
  )
}

export default CountriesSelectItem;
